export default {
  data() {
    return {};
  },
  watch: {},
  created() {},
  activated() {},
  mounted() {},
  methods: {
    formatTime(time = new Date()) {
      const year = time.getFullYear();
      const month = String(time.getMonth() + 1).padStart(2, "0");
      const day = String(time.getDate()).padStart(2, "0");
      const hours = String(time.getHours()).padStart(2, "0");
      const minutes = String(time.getMinutes()).padStart(2, "0");
      const seconds = String(time.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formatNumber(value) {
      if (!value && value !== 0) return "";
      // const number = parseFloat(value).toFixed(2);
      const number = parseFloat(value).toFixed(0);
      return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
